/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: ({theme}) => ({
        container: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            minWidth: '375px',

            sx: {
                '.apple-pay-button': {
                    width: 'full',
                    borderRadius: 'full',
                    paddingBlock: 2.5,
                    paddingInline: 6
                }
            }
        },
        headerWrapper: {
            position: 'fixed',
            top: 0,
            width: 'full',
            maxWidth: 'var(--max-viewport-width)',
            zIndex: theme.zIndices.sticky,
            // disable pointer events to allow hidden header to allow interaction with elements below
            pointerEvents: 'none'
        }
    }),
    parts: ['container', 'headerWrapper']
}
